import { HttpEventType } from '@angular/common/http';
import { Component, inject, Input } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';
import { Subscription } from 'rxjs';
import { FileService } from '../../file/file.service';
import { BaseComponent } from '../../shared/base.component';
import { SiteHeaderComponent } from '../../site-header/site-header.component';

@Component({
    selector: 'app-log-upload',
    standalone: true,
    imports: [
        MatProgressBar,
        MatButtonModule,
        SiteHeaderComponent
    ],
    templateUrl: './upload-log.component.html',
    styleUrl: './upload-log.component.css'
})
export class UploadLogComponent extends BaseComponent {

    @Input() requiredFileType: string = "";

    private fileService: FileService = inject(FileService);

    private static _uploadingLogFile = "Uploading Log File";
    private static _uploadingLogFileError = `${UploadLogComponent._uploadingLogFile} error:`;

    protected percentDone: number = 100;
    protected uploadSub: Subscription | null | undefined;

    public constructor() {
        super();
    }

    public async uploadFile(event: any) {
        const file: File = event.target?.files[0];
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            if (file) {
                const observable = this.fileService.getUploadUrl(await getIdToken(currentUser), "log", file.name)
                super.showSnackBar(`${UploadLogComponent._uploadingLogFile}...`, -1);

                observable.subscribe(response => {
                    try {
                        const json = JSON.parse(JSON.stringify(response));

                        if (json["get-log-upload-url"] == "success") {
                            this.initiateUpload(file, json["url"]);
                        } else {
                            throw new Error(json["message"]);
                        }
                    } catch (error) {
                        const message = `${UploadLogComponent._uploadingLogFileError} ${(<Error>error).message}`;
                        console.error(message);
                        super.showSnackBar(message, 30);
                    }
                });
            } else {
                const message = `${UploadLogComponent._uploadingLogFileError} Null file instance`;
                console.error(message)
                super.showSnackBar(message, 30);
            }
        } else {
            const message = `${UploadLogComponent._uploadingLogFileError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }

    private async initiateUpload(file: File, url: string) {
        const currentUser = this.auth.currentUser;
        const observable = this.fileService.uploadFile(file, url);

        try {
            this.uploadSub = observable.subscribe(event => {
                switch (event.type) {
                    case HttpEventType.Sent:
                        break;
                    case HttpEventType.ResponseHeader:
                        break;
                    case HttpEventType.UploadProgress:
                        this.percentDone = 0;
                        if (event.total != undefined) {
                            this.percentDone = Math.round(100 * event.loaded / event.total);
                        }
                        break;
                    case HttpEventType.Response:
                        if (event.status == 204) {
                            this.showSnackBar(`Upload completed.`);
                        } else {
                            throw new Error(`Upload failed, status: ${event.status}, statusText: ${event.statusText}`);
                        }
                        break;
                }
            });
        } catch (error) {
            const message = `${UploadLogComponent._uploadingLogFileError} ${(<Error>error).message}`;
            console.error(message);
            super.showSnackBar(message, 30);
        }
    }

    private reset() {
        this.percentDone = 100;
        this.uploadSub = null;
    }

    protected cancelUpload() {
        this.uploadSub?.unsubscribe();
        this.reset();
    }
}
